import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  totalPogs: 0,
  selected: 0,
  existing: 0,
  lf: 0,
  adjLf: 0,
  skuQty: 0,
  adjCost: 0,
  extCost: 0,
  availableCreditLimit: 0,
  creditLimit: 0,
};

export const totalSlice = createSlice({
  name: "total",
  initialState,
  reducers: {
    setTotalDetails: (state, { payload }) => {
      state.totalPogs = payload?.TotalPogs ?? 0;
      state.selected = payload?.SelectedPogs ?? 0;
      state.existing = payload?.ExistingPogs ?? 0;
      state.lf = payload?.LinealFootage ?? 0;
      state.adjLf = payload?.AdjLineal ?? 0;
      state.skuQty = payload?.SkuQty ?? 0;
      state.adjCost = payload?.AdjCost ?? 0;
      state.extCost = payload?.ExtendedCost ?? 0;
      state.availableCreditLimit = payload?.AvailableCreditLimit ?? 0;
      state.creditLimit = payload?.CreditLimit ?? 0;
    },
  },
});

export const { setTotalDetails } = totalSlice.actions;

export default totalSlice.reducer;
